import { render, staticRenderFns } from "./NormativityBack.vue?vue&type=template&id=f0369c08&lang=pug&"
import script from "./NormativityBack.vue?vue&type=script&lang=js&"
export * from "./NormativityBack.vue?vue&type=script&lang=js&"
import style0 from "./NormativityBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0369c08')) {
      api.createRecord('f0369c08', component.options)
    } else {
      api.reload('f0369c08', component.options)
    }
    module.hot.accept("./NormativityBack.vue?vue&type=template&id=f0369c08&lang=pug&", function () {
      api.rerender('f0369c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/NormativityBack.vue"
export default component.exports